// @core/api/endpoints/document/delete_clause.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/document';

/**
 * Delete clause
 * Soft-deletes a clause. Deletion is blocked if the clause is still referenced by any APPROVED DocumentTemplate.
 */
export async function DeleteClause(
  clause_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/clauses/:clause_id`;
  requestPath = requestPath.replace(':clause_id', encodeURIComponent(clause_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
